import { ENV } from '../../environment';

type Config = {
  endpoint: string;
};

const DevEnv: Config = {
  endpoint: 'https://api2.dev.concreit.com',
};

const StagingEnv: Config = {
  endpoint: 'https://api2.staging.concreit.com',
};

const ProdEnv: Config = {
  endpoint: 'https://api2.concreit.com',
};

export const config: Config = ENV === 'development' ? DevEnv : ENV === 'production' ? ProdEnv : StagingEnv;
